module.exports = __webpack_public_path__ + "static/carousel6-a73c9dd4a0e63bb83b05a8f6f886c593.jpg";